import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import CacheStorage from '../cache/cache.storage';
import { VersionRelease, Banner } from '@matap/shared';

const reducer = createSlice({
  name: 'configs.reducer',
  initialState: {
    banners: [] as Banner[],
    supportPhoneNumber: null as string,
    latestVersion: null as VersionRelease | null,
  },
  reducers: {
    actionSetConfigs(state, action: PayloadAction<Partial<{ banners: Banner[]; supportPhoneNumber: string; latestVersion: VersionRelease | null }>>) {
      state.banners = action.payload.banners || state.banners;
      state.supportPhoneNumber = action.payload.supportPhoneNumber || state.supportPhoneNumber;
      state.latestVersion = action.payload.latestVersion || state.latestVersion;
      CacheStorage.set('banners', JSON.stringify(state.banners));
      CacheStorage.set('supportPhoneNumber', state.supportPhoneNumber);
    },
  },
});

export const { actionSetConfigs } = reducer.actions;
export default reducer.reducer;
